import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-map-bus',
  templateUrl: './map-bus.component.html',
  styleUrls: ['./map-bus.component.scss']
})
export class MapBusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
